/* =============================================
   ZAAVI MART — Shopify Theme JS
   ============================================= */

/* ---- Scroll Progress Bar ---- */
var progressBar = document.getElementById('pageProgress');
var scrollTopBtn = document.getElementById('scrollTop');

window.addEventListener('scroll', function() {
  var scrolled = window.scrollY;
  var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  if (progressBar) progressBar.style.width = (scrolled / maxScroll * 100) + '%';
  if (scrollTopBtn) {
    if (scrolled > 350) scrollTopBtn.classList.add('visible');
    else scrollTopBtn.classList.remove('visible');
  }
}, { passive: true });

/* ---- Mobile Drawer ---- */
var hamburger = document.getElementById('hamburger');
var drawerOverlay = document.getElementById('drawerOverlay');
var navDrawer = document.getElementById('navDrawer');

function openDrawer() {
  if (hamburger) hamburger.classList.add('open');
  if (drawerOverlay) drawerOverlay.classList.add('open');
  if (navDrawer) navDrawer.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  if (hamburger) hamburger.classList.remove('open');
  if (drawerOverlay) drawerOverlay.classList.remove('open');
  if (navDrawer) navDrawer.classList.remove('open');
  document.body.style.overflow = '';
}

if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeDrawer();
    closeQV();
  }
});

/* ---- Quick View Modal ---- */
function openQV(productId, productData) {
  var overlay = document.getElementById('qvOverlay');
  var imgWrap = document.getElementById('qvImg');
  var details = document.getElementById('qvDetails');
  if (!overlay) return;

  var p = productData;
  if (typeof p === 'string') {
    try { p = JSON.parse(p); } catch(e) { return; }
  }

  var img = p.featured_image
    ? '<img src="' + (p.featured_image.src || p.featured_image) + '" alt="' + (p.title || '') + '" style="width:100%;height:100%;object-fit:cover;border-radius:16px;">'
    : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:80px;background:#f8f0ff;border-radius:16px;">🛍️</div>';

  var price = p.price ? 'Rs. ' + (p.price / 100).toLocaleString() : '';
  var compare = (p.compare_at_price && p.compare_at_price > p.price)
    ? '<span style="text-decoration:line-through;color:#aaa;font-size:16px;margin-left:8px;">Rs. ' + (p.compare_at_price / 100).toLocaleString() + '</span>'
    : '';

  imgWrap.innerHTML = '<button class="qv-close" onclick="closeQV()">×</button>' + img;
  details.innerHTML = '<h2 style="font-size:22px;font-weight:900;color:#0F0A1A;margin-bottom:12px;">' + (p.title || '') + '</h2>'
    + '<div style="display:flex;align-items:baseline;gap:8px;margin-bottom:20px;">'
    + '<span style="font-size:28px;font-weight:900;color:var(--pink);">' + price + '</span>' + compare + '</div>'
    + (p.body_html ? '<div style="font-size:14px;color:#666;line-height:1.7;margin-bottom:24px;max-height:120px;overflow:auto;">' + p.body_html.replace(/<[^>]+>/g,'').substring(0, 300) + '</div>' : '')
    + '<div style="display:flex;gap:12px;flex-wrap:wrap;">'
    + (p.variants && p.variants[0]
      ? '<button class="p-cart-btn" style="flex:1;" onclick="addToCart(this,' + p.variants[0].id + ',1)">🛒 Add to Cart</button>'
      : '')
    + '<a href="/products/' + (p.handle || '') + '" class="btn-outline" style="flex:1;justify-content:center;">View Full Details</a>'
    + '</div>';

  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeQV() {
  var overlay = document.getElementById('qvOverlay');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

/* ---- Cart Functions ---- */
function addToCart(btn, variantId, qty) {
  if (!variantId) return;
  qty = qty || 1;

  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (btn) {
      btn.classList.add('added');
      btn.textContent = '✓ Added!';
      setTimeout(function() {
        btn.disabled = false;
        btn.classList.remove('added');
        btn.textContent = '🛒 Add to Cart';
      }, 2000);
    }
    updateCartCount();
    showCartToast(data.title);
  })
  .catch(function(err) {
    if (btn) {
      btn.disabled = false;
      btn.textContent = '🛒 Add to Cart';
    }
    console.error('Cart error:', err);
  });
}

function updateCartQty(lineKey, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: qty })
  })
  .then(function() { location.reload(); })
  .catch(function(err) { console.error('Cart update error:', err); });
}

function updateCartCount() {
  fetch('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var badge = document.getElementById('cartCount');
    if (badge) badge.textContent = cart.item_count;
  });
}

function showCartToast(productTitle) {
  var existing = document.getElementById('cartToast');
  if (existing) existing.remove();

  var toast = document.createElement('div');
  toast.id = 'cartToast';
  toast.innerHTML = '<span>✓ Added to cart!</span> <a href="/cart" style="color:white;font-weight:700;text-decoration:underline;">View Cart</a>';
  toast.style.cssText = 'position:fixed;bottom:100px;left:50%;transform:translateX(-50%);background:linear-gradient(135deg,#22c55e,#16a34a);color:white;padding:12px 24px;border-radius:50px;font-size:14px;font-weight:600;z-index:9999;box-shadow:0 8px 24px rgba(0,0,0,0.2);display:flex;align-items:center;gap:12px;animation:slideUp 0.3s ease;white-space:nowrap;';
  document.body.appendChild(toast);
  setTimeout(function() { toast.style.opacity = '0'; toast.style.transition = 'opacity 0.3s'; setTimeout(function() { toast.remove(); }, 300); }, 3000);
}

/* ---- Wishlist (localStorage) ---- */
function toggleWishlist(btn, productId) {
  var wishlist = JSON.parse(localStorage.getItem('zm_wishlist') || '[]');
  var idx = wishlist.indexOf(productId);
  if (idx > -1) {
    wishlist.splice(idx, 1);
    btn.style.filter = '';
  } else {
    wishlist.push(productId);
    btn.style.filter = 'hue-rotate(0deg) saturate(3)';
  }
  localStorage.setItem('zm_wishlist', JSON.stringify(wishlist));
}

/* ---- Scroll Reveal (auto-targets all major cards/items) ---- */
document.addEventListener('DOMContentLoaded', function() {

  /* 1. Fade-in for explicit .fade-in elements */
  var fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.fade-in').forEach(function(el) { fadeObserver.observe(el); });

  /* 2. Auto-reveal with stagger for card grids */
  var CARD_SELECTORS = [
    '.cat-card-colored', '.why-card', '.review-card', '.p-card',
    '.trust-item', '.promo-card', '.section-header',
    '.why-us-section .section-header', '.reviews-section .section-header'
  ];

  function initCardReveal() {
    var allCards = document.querySelectorAll(CARD_SELECTORS.join(','));
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });

    /* Group cards by their parent container for stagger effect */
    var containers = {};
    allCards.forEach(function(card) {
      var parent = card.parentElement;
      if (!parent) return;
      var key = parent.dataset.revealGroup || (parent.dataset.revealGroup = 'g' + Math.random());
      if (!containers[key]) containers[key] = [];
      containers[key].push(card);
    });

    Object.values(containers).forEach(function(group) {
      group.forEach(function(card, i) {
        card.style.opacity = '0';
        card.style.transform = 'translateY(26px)';
        card.style.transition = 'opacity 0.58s ease ' + (i * 0.07).toFixed(2) + 's, transform 0.58s cubic-bezier(.22,.61,.36,1) ' + (i * 0.07).toFixed(2) + 's';
        revealObs.observe(card);
      });
    });
  }

  initCardReveal();

  /* 3. Section headers slide up */
  var headerObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        headerObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.section-header, .reviews-header, .why-us-section > div:first-child, .cta-banner-inner').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(22px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    headerObs.observe(el);
  });

  /* 4. Restore wishlist state */
  var wishlist = JSON.parse(localStorage.getItem('zm_wishlist') || '[]');
  document.querySelectorAll('.p-wishlist').forEach(function(btn) {
    var card = btn.closest('.p-card');
    if (card) {
      var variantBtn = card.querySelector('.p-cart-btn');
      if (variantBtn && wishlist.includes(parseInt(variantBtn.dataset.variant))) {
        btn.style.filter = 'hue-rotate(0deg) saturate(3)';
      }
    }
  });

  /* 5. Animate hero stats counting up */
  var statEls = document.querySelectorAll('.hero-stat strong, [data-count]');
  if (statEls.length) {
    var statObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        statObs.unobserve(entry.target);
        var el = entry.target;
        var target = el.dataset.count || el.textContent;
        var num = parseFloat(target.replace(/[^0-9.]/g,''));
        var suffix = target.replace(/[0-9.]/g,'');
        if (!num) return;
        var start = 0;
        var duration = 1400;
        var startTime = null;
        function tick(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          var val = Math.round(start + (num - start) * ease);
          el.textContent = (num >= 1000 ? (val/1000).toFixed(val >= 10000 ? 0 : 1) + 'K' : val) + suffix.replace('K','').trim();
          if (progress < 1) requestAnimationFrame(tick);
          else el.textContent = target;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    statEls.forEach(function(el) { statObs.observe(el); });
  }

});

/* ---- Buy Now → Direct Checkout ---- */
window.buyNow = function(variantId) {
  var btn = document.getElementById('buyNowBtn');
  if (btn) { btn.disabled = true; btn.innerHTML = '⌛ Processing...'; }
  var qty = parseInt((document.getElementById('qtyInput') || {}).value) || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(function() { window.location.href = '/checkout'; })
  .catch(function() { window.location.href = '/checkout'; });
};

/* ---- Animation keyframes injected via JS ---- */
var style = document.createElement('style');
style.textContent = '@keyframes slideUp { from { opacity:0; transform:translateX(-50%) translateY(20px); } to { opacity:1; transform:translateX(-50%) translateY(0); } } .fade-in { opacity:0; transform:translateY(24px); transition:opacity 0.55s ease, transform 0.55s ease; } .fade-in.visible { opacity:1; transform:translateY(0); }';
document.head.appendChild(style);
